import type {ProjectStage} from '../../../shared/util/ProjectStages';

export const SECTION_EXPANDED_MAP_KEY = 'projects-page-section-expanded-map';

// Temporary: remove with the custom_project_stages flag clean-up
// Before sections were keyed by company stage id, the saved map was keyed by profile name.
const LEGACY_PROFILE_KEYS = ['OPPORTUNITY', 'PLANNING', 'RUNNING', 'HALTED', 'DONE'];

// Temporary: remove with the custom_project_stages flag clean-up
export const isLegacyProfileKey = (key: unknown): boolean => typeof key === 'string' && LEGACY_PROFILE_KEYS.includes(key);

type SectionStage = Pick<ProjectStage, 'id' | 'profile'>;

// Temporary: remove with the custom_project_stages flag clean-up
// Moves each legacy profile entry onto the stages with that profile that have no entry of their own, and drops the
// legacy key. Returns whether the map changed, so the caller can save it once.
export const translateLegacyProfileKeys = (
	expandedMap: Map<string, boolean>,
	stages: ReadonlyArray<SectionStage>
): {expandedMap: Map<string, boolean>; changed: boolean} => {
	const translated = new Map(expandedMap);
	let changed = false;
	expandedMap.forEach((expanded, key) => {
		if (!isLegacyProfileKey(key)) return;
		stages.forEach(stage => {
			if (stage.profile === key && !translated.has(stage.id)) translated.set(stage.id, expanded);
		});
		translated.delete(key);
		changed = true;
	});
	return {expandedMap: translated, changed};
};

// True when a Done- or Halted-profile section is saved as expanded: by stage id, or by a legacy profile key not
// yet translated by the page.
export const hasExpandedDoneOrHaltedSection = (
	expandedMap: ReadonlyMap<string, boolean>,
	stages: ReadonlyArray<SectionStage>
): boolean => {
	// Temporary: remove with the custom_project_stages flag clean-up
	if (expandedMap.get('DONE') || expandedMap.get('HALTED')) return true;
	return stages.some(stage => (stage.profile === 'DONE' || stage.profile === 'HALTED') && !!expandedMap.get(stage.id));
};
